import HistoryCheckinFaceIcon from '@material-ui/icons/ViewList';

import HistoryCheckinFaceList from './HistoryCheckinFaceList';

export default {
    list: HistoryCheckinFaceList,
    icon: HistoryCheckinFaceIcon,
};
